module.exports = __webpack_public_path__ + "img/img-8.15d6d17d.webp";